const convertArrayOfOrganizationToArrayOfAccountList = (organizationData) => {
    let tempData = []
    organizationData.forEach((organiztion) => {
        tempData.push(organiztion['AccountId'])
    })
    return tempData.reverse()
}

export {convertArrayOfOrganizationToArrayOfAccountList}